<template>
  <div>
    <PageAllow controller="Settings" action="otherSetting" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color my-3 mx-6">
        <v-expansion-panels v-model="panels" multiple focusable>
          <!-- 联系方式 -->
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t("OtherSettings.Fields.contact_information") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-spacer />
                    <v-tooltip top v-if="contactDisabled">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          dark
                          outlined
                          color="primary"
                          class="mr-3"
                          @click="contactDisabled = false"
                        >
                          {{ $t("CRUD.edit") }}
                        </v-btn>
                      </template>
                      <span>
                        {{
                          $t("CRUD.editInfo", [
                            $t("OtherSettings.Fields.contact_information"),
                          ])
                        }}
                      </span>
                    </v-tooltip>
                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          dark
                          color="primary"
                          class="mr-3"
                          @click="submit('contact')"
                        >
                          {{ $t("CRUD.save") }}
                        </v-btn>
                      </template>
                      <span>
                        {{
                          $t("CRUD.saveInfo", [
                            $t("OtherSettings.Fields.contact_information"),
                          ])
                        }}
                      </span>
                    </v-tooltip>
                  </v-row>
                  <div class="mt-5">
                    <VEditor
                      v-model="settingValues.help_contact_html"
                      :disabled="contactDisabled"
                    />
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 订货规则 -->
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t("OtherSettings.Fields.order_rule") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-spacer />
                    <v-tooltip top v-if="orderRuleDisabled">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          dark
                          outlined
                          color="primary"
                          class="mr-3"
                          @click="orderRuleDisabled = false"
                        >
                          {{ $t("CRUD.edit") }}
                        </v-btn>
                      </template>
                      <span>
                        {{
                          $t("CRUD.editInfo", [
                            $t("OtherSettings.Fields.order_rule"),
                          ])
                        }}
                      </span>
                    </v-tooltip>
                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          dark
                          color="primary"
                          class="mr-3"
                          @click="submit('order_rule')"
                        >
                          {{ $t("CRUD.save") }}
                        </v-btn>
                      </template>
                      <span>
                        {{
                          $t("CRUD.saveInfo", [
                            $t("OtherSettings.Fields.order_rule"),
                          ])
                        }}
                      </span>
                    </v-tooltip>
                  </v-row>
                  <div class="mt-5">
                    <VEditor
                      v-model="settingValues.help_order_rule_html"
                      :disabled="orderRuleDisabled"
                    />
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 使用说明 -->
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t("OtherSettings.Fields.user_guide") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-spacer />
                    <v-tooltip top v-if="userGuideDisabled">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          dark
                          outlined
                          color="primary"
                          class="mr-3"
                          @click="userGuideDisabled = false"
                        >
                          {{ $t("CRUD.edit") }}
                        </v-btn>
                      </template>
                      <span>
                        {{
                          $t("CRUD.editInfo", [
                            $t("OtherSettings.Fields.user_guide"),
                          ])
                        }}
                      </span>
                    </v-tooltip>
                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          dark
                          color="primary"
                          class="mr-3"
                          @click="submit('user_guide')"
                        >
                          {{ $t("CRUD.save") }}
                        </v-btn>
                      </template>
                      <span>
                        {{
                          $t("CRUD.saveInfo", [
                            $t("OtherSettings.Fields.user_guide"),
                          ])
                        }}
                      </span>
                    </v-tooltip>
                  </v-row>
                  <div class="mt-5">
                    <VEditor
                      v-model="settingValues.help_user_guide_html"
                      :disabled="userGuideDisabled"
                    />
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import VEditor from "@/plugins/VEditor";
import Settings from "@/api/settings";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    VEditor,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.settings"),
        disabled: false,
        href: "/settings/bussiness-settings",
      },
      {
        text: i18n.t("SettingNav.otherSetting"),
        disabled: true,
        href: "/settings/bussiness-settings",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountInfo"]),
  },

  data: () => ({
    panels: [0, 1, 2],
    settingKeys: {
      keys: [
        "help_contact_html",
        "help_order_rule_html",
        "help_user_guide_html",
      ],
    },
    settingValues: {},
    contactDisabled: true,
    orderRuleDisabled: true,
    userGuideDisabled: true,
  }),

  mounted() {
    this.getSettings();
  },

  methods: {
    getSettings() {
      //获取设置
      Settings.fetch(this.settingKeys).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settingValues = response.data.settings;
          }
        }.bind(this)
      );
    },
    
    submit(type) {
      if (type == "contact") {
        Settings.batchSave([
          {
            setting_key: "help_contact_html",
            setting_value: this.settingValues.help_contact_html,
          },
        ]).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("OtherSettings.Messages.save_contact_success"));
              this.getSettings();
              this.contactDisabled = true;
            }
          }.bind(this)
        );
      } else if (type == "order_rule") {
        Settings.batchSave([
          {
            setting_key: "help_order_rule_html",
            setting_value: this.settingValues.help_order_rule_html,
          },
        ]).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("OtherSettings.Messages.save_order_rule_success"));
              this.getSettings();
              this.orderRuleDisabled = true;
            }
          }.bind(this)
        );
      } else if (type == "user_guide") {
        Settings.batchSave([
          {
            setting_key: "help_user_guide_html",
            setting_value: this.settingValues.help_user_guide_html,
          },
        ]).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("OtherSettings.Messages.save_user_guide_success"));
              this.getSettings();
              this.userGuideDisabled = true;
            }
          }.bind(this)
        );
      }
    },
  },
};
</script>